import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/auth.css";

export default function OnboardingSuccess() {
  const nav = useNavigate();

  return (
    <div className="auth-wrap">
      <div className="auth-topbar">
        <div style={{ fontWeight: 800, color: "#174350" }}>QAVACH</div>
        <div style={{ color: "#777" }}>Done</div>
      </div>

      <div className="auth-accent">Onboarding Completed ✅</div>

      <div className="auth-card">
        <h2 className="auth-title">Profile Submitted</h2>
        <p className="auth-sub">
          Your profile is submitted. Admin will approve your account. After approval, you can login.
        </p>

         <button
  className="auth-btn"
  onClick={() => {
    sessionStorage.clear();
    nav("/");
  }}
>
  Go to Login
</button>
      </div>
    </div>
  );
}
